<div class="mb-3" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id" [innerHTML]="props.label"></label>
  <div>
    <form [formGroup]="formSize">
      <div class="form-control-group">
        <div class="me-2">
          <label *ngIf="props.label && props.hideLabel !== true" for="widthSize" i18n="@@WidthSizeLabel">Шинина</label>
          <input nbInput
                 id="widthSize"
                 fieldSize="small"
                 [placeholder]="widthPlaceholder"
                 formControlName="width"
          />
        </div>

        <div class="me-2">
          <label *ngIf="props.label && props.hideLabel !== true" for="heightSize" i18n="@@HeightSizeLabel">Высота</label>
          <input nbInput
                 id="heightSize"
                 fieldSize="small"
                 [placeholder]="heightPlaceholder"
                 formControlName="height"
          />
        </div>

        <div class="me-2">
          <label *ngIf="props.label && props.hideLabel !== true" for="depthSize" i18n="@@DepthSizeLabel">Глубина</label>
          <input nbInput
                 id="depthSize"
                 fieldSize="small"
                 [placeholder]="depthPlaceholder"
                 formControlName="depth"
          />
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
